/**
 * Arabic for the stores register held by the platform (features/stores/useStores.ts):
 * where the register is kept, and the one-time move of the note onto the
 * platform. Proposed; pending native procurement review.
 *
 * The desk's own vocabulary is in stores.ts and is not repeated here: on hand
 * المتوفر فعلياً, reserved المحجوز, available المتاح. "The note" is ملاحظة, as
 * the site notes are called elsewhere on the platform.
 */
const ar: Record<string, string> = {
  "This change could not be sent to the platform, so it was not kept.":
    "تعذّر إرسال هذا التغيير إلى المنصة، فلم يُحفظ.",
  "Brought onto the platform: {items} lines and {movements} movements. The platform keeps the register from now on.":
    "نُقل إلى المنصة: {items} صنفاً و{movements} حركة. تحتفظ المنصة بالسجل من الآن فصاعداً.",
  "Held in the platform's stores register: every movement is checked there before it is kept, so the shelf cannot go below nothing and two people cannot take the same last part. Consumption is counted from the movements recorded — anything taken off the shelf without being booked out is invisible to every figure below.":
    "محفوظ في سجل المخازن على المنصة: تُفحص كل حركة هناك قبل حفظها، فلا يمكن أن ينزل الرف تحت الصفر ولا أن يأخذ شخصان آخر قطعة نفسها. يُحسب الاستهلاك من الحركات المسجلة — وكل ما يُؤخذ من الرف دون قيد صرفه لا يظهر في أي رقم أدناه.",
  "The platform now keeps a stores register of its own. This one is still kept as a note: bring it across once, and every line, movement, reservation, request and order moves with it, under the names and dates it was recorded with.":
    "أصبحت المنصة تحتفظ بسجل مخازن خاص بها. أما هذا السجل فما زال محفوظاً كملاحظة: انقله مرة واحدة، فينتقل معه كل صنف وحركة وحجز وطلب شراء وأمر شراء، بالأسماء والتواريخ التي سُجّل بها.",
  "Bringing it across…": "جارٍ النقل…",
  "Bring it onto the platform": "انقله إلى المنصة",
};

export default ar;
